export default {
    "name": "GetRoadsheet",
    "kind": "HoudiniQuery",
    "hash": "89d57563abd19351e6c5cd625d510095e2924f7494029400817b6fe31ca5dfc7",

    "raw": `query GetRoadsheet($input: GetRoadsheetInput!) {
  getRoadsheet(input: $input) {
    ... on GetRoadsheetSuccessResult {
      __typename
      climateLawMessage {
        type
        text
        hashtag
      }
      roadsheet
      roadDetail {
        highwayDistance {
          value
          unit
        }
        highwayDuration
        roadsWithoutHighwayDistance {
          value
          unit
        }
        roadsWithoutHighwayDuration
        scenicDistance {
          value
          unit
        }
      }
      lezMentions {
        message
        url
        urlName
      }
    }
    ... on GetRoadsheetNotFoundResult {
      message
    }
    __typename
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getRoadsheet": {
                "type": "GetRoadsheetResult",
                "keyRaw": "getRoadsheet(input: $input)",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "GetRoadsheetSuccessResult": {
                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                },

                                "climateLawMessage": {
                                    "type": "ClimateLawMessage",
                                    "keyRaw": "climateLawMessage",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "type": {
                                                "type": "ClimateLawType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "text": {
                                                "type": "String",
                                                "keyRaw": "text",
                                                "visible": true
                                            },

                                            "hashtag": {
                                                "type": "String",
                                                "keyRaw": "hashtag",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "roadsheet": {
                                    "type": "String",
                                    "keyRaw": "roadsheet",
                                    "nullable": true,
                                    "visible": true
                                },

                                "roadDetail": {
                                    "type": "RoadsheetDetail",
                                    "keyRaw": "roadDetail",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "highwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "highwayDistance",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "highwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "highwayDuration",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDistance": {
                                                "type": "Distance",
                                                "keyRaw": "roadsWithoutHighwayDistance",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "roadsWithoutHighwayDuration": {
                                                "type": "Int",
                                                "keyRaw": "roadsWithoutHighwayDuration",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "scenicDistance": {
                                                "type": "Distance",
                                                "keyRaw": "scenicDistance",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "value": {
                                                            "type": "Float",
                                                            "keyRaw": "value",
                                                            "visible": true
                                                        },

                                                        "unit": {
                                                            "type": "DistanceUnit",
                                                            "keyRaw": "unit",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "lezMentions": {
                                    "type": "RestrictedZoneMention",
                                    "keyRaw": "lezMentions",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "message": {
                                                "type": "String",
                                                "keyRaw": "message",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "url": {
                                                "type": "String",
                                                "keyRaw": "url",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "urlName": {
                                                "type": "String",
                                                "keyRaw": "urlName",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                }
                            },

                            "GetRoadsheetNotFoundResult": {
                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetRoadsheetInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "GetRoadsheetInput": {
                "arrivalName": "String",
                "carId": "String",
                "constraint": "ItineraryConstraint",
                "coordinates": "CoordinatesInput",
                "currency": "Currency",
                "departureName": "String",
                "distanceSystem": "DistanceSystem",
                "energyCost": "Float",
                "initialChargeLevel": "Float",
                "mode": "ItineraryTravelMode",
                "rechargeTreshold": "Float",
                "routeIdentifier": "String",
                "routeIndex": "Int",
                "traffic": "ItineraryTrafficMode",
                "withCaravan": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=dd4ebcc6570fc5e52d06a671d3dd5775a3b08e483733e89deafb008519ec57dd";